export const API_BASE_URL = process.env.REACT_APP_ENV === 'PRODUCTION'
  ? '/api'
  : 'http://localhost:8000';
